{
  "familyId": "MET-INH-OMREKEN-KUBIEK",
  "questions": [
    {
      "id": "MET-INH-OMREKEN-KUBIEK-001",
      "familyId": "MET-INH-OMREKEN-KUBIEK",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_kubiek_omreken",
      "questionType": "multiple_choice",
      "question": "Hoeveel liter is 3 dm³?",
      "options": ["3 liter", "30 liter", "0,3 liter", "300 liter"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "dm³ = liter",
            "content": "Onthoud: 1 dm³ is precies 1 liter. Dus 3 dm³ = 3 liter. Geen extra vermenigvuldiging nodig!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_kubiek_dm3_liter",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "1 dm³ is precies 1 liter. Dus 3 dm³ = 3 liter. Dit is de belangrijkste koppeling bij inhoud omrekenen. Waarom? Een dm³ is een kubus van 10 cm × 10 cm × 10 cm — dat is precies 1 liter.",
        "solutionSteps": [
          "Ken de regel: 1 dm³ = 1 liter",
          "Vermenigvuldig: 3 × 1 = 3 liter",
          "Antwoord: 3 dm³ = 3 liter"
        ],
        "distractorExplanations": {
          "0": "Goed! 1 dm³ = 1 liter, dus 3 dm³ = 3 liter.",
          "1": "Je dacht waarschijnlijk dat je met 10 moest vermenigvuldigen. Maar dm³ en liter zijn precies gelijk: 1 dm³ = 1 liter. Onthoud: dm³ = liter, zonder extra stap.",
          "2": "Je dacht waarschijnlijk dat je moest delen. Maar 1 dm³ = 1 liter, dus 3 dm³ = 3 liter, niet 0,3 liter. Onthoud: dm³ en liter zijn gelijk.",
          "3": "Je dacht waarschijnlijk dat je met 100 moest vermenigvuldigen. Maar dat geldt voor cm² → dm², niet voor dm³ → liter. Onthoud: 1 dm³ = 1 liter."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.kubiek-x10-i.p.v.-x1000", "label": "Past lengte-regel toe", "optionIndex": 1 },
          { "id": "met.kubiek-delen-i.p.v.-vermenigvuldigen", "label": "Deelt in plaats van vermenigvuldigen", "optionIndex": 2 },
          { "id": "met.kubiek-x100-i.p.v.-x1000", "label": "Past oppervlakte-regel toe", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-OMREKEN-KUBIEK-002",
      "familyId": "MET-INH-OMREKEN-KUBIEK",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_kubiek_omreken",
      "questionType": "multiple_choice",
      "question": "Hoeveel dm³ is 1 m³?",
      "options": ["100 dm³", "10 dm³", "1000 dm³", "10.000 dm³"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kubiek omrekenen",
            "content": "Bij kubieke maten vermenigvuldig je met 1000 per stap. 1 m = 10 dm, dus 1 m³ = 10 × 10 × 10 = 1000 dm³.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_kubiek_m3_dm3",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "1 meter = 10 decimeter. Bij kubieke maten reken je in drie richtingen: 10 × 10 × 10 = 1000. Dus 1 m³ = 1000 dm³. Dit is het grote verschil met lengte (×10) en oppervlakte (×100): bij kubiek is het altijd ×1000 per stap.",
        "solutionSteps": [
          "1 m = 10 dm (lengte)",
          "Kubiek = drie richtingen: 10 × 10 × 10",
          "10 × 10 × 10 = 1000",
          "Dus 1 m³ = 1000 dm³"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je met 100 moest vermenigvuldigen. Dat geldt voor vierkante maten (10 × 10 = 100). Bij kubiek is het 10 × 10 × 10 = 1000. Onthoud: kubiek = ×1000 per stap.",
          "1": "Je dacht waarschijnlijk dat je met 10 moest vermenigvuldigen. Dat geldt voor lengte (1 m = 10 dm). Bij kubiek vermenigvuldig je drie keer: 10 × 10 × 10 = 1000. Onthoud: kubiek = drie keer vermenigvuldigen.",
          "2": "Goed! 1 m = 10 dm, en kubiek = 10³ = 1000. Dus 1 m³ = 1000 dm³.",
          "3": "Je dacht waarschijnlijk dat je met 10.000 moest vermenigvuldigen. Maar 10⁴ = 10.000 is vier keer vermenigvuldigen. Kubiek is drie keer: 10³ = 1000. Onthoud: kubiek = ×1000."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.kubiek-x100-i.p.v.-x1000", "label": "Past oppervlakte-regel toe", "optionIndex": 0 },
          { "id": "met.kubiek-x10-i.p.v.-x1000", "label": "Past lengte-regel toe", "optionIndex": 1 },
          { "id": "met.kubiek-x10000-i.p.v.-x1000", "label": "Vermenigvuldigt een keer te veel", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-OMREKEN-KUBIEK-003",
      "familyId": "MET-INH-OMREKEN-KUBIEK",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_kubiek_omreken",
      "questionType": "multiple_choice",
      "question": "Een aquarium heeft een inhoud van 0,06 m³. Hoeveel liter water past erin?",
      "options": ["6 liter", "60 liter", "600 liter", "0,6 liter"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "m³ naar liter",
            "content": "Reken eerst om naar dm³: 1 m³ = 1000 dm³. Dan: 1 dm³ = 1 liter. Dus 0,06 m³ = 0,06 × 1000 = 60 dm³ = 60 liter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_kubiek_m3_liter_context",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Stap 1: Reken m³ om naar dm³. 1 m³ = 1000 dm³, dus 0,06 m³ = 0,06 × 1000 = 60 dm³. Stap 2: 1 dm³ = 1 liter, dus 60 dm³ = 60 liter. Dit is een tweestapsberekening: eerst kubiek omrekenen, dan de koppeling dm³ = liter gebruiken.",
        "solutionSteps": [
          "1 m³ = 1000 dm³ (kubiek = ×1000)",
          "0,06 × 1000 = 60 dm³",
          "1 dm³ = 1 liter → 60 dm³ = 60 liter"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je met 100 moest vermenigvuldigen. Maar bij kubiek is het ×1000: 0,06 × 1000 = 60, niet 0,06 × 100 = 6. Onthoud: m³ → dm³ = ×1000.",
          "1": "Goed! 0,06 m³ × 1000 = 60 dm³ = 60 liter.",
          "2": "Je dacht waarschijnlijk dat je met 10.000 moest vermenigvuldigen. Maar m³ → dm³ = ×1000, niet ×10.000. Dus 0,06 × 1000 = 60 liter. Onthoud: kubiek = ×1000 per stap.",
          "3": "Je dacht waarschijnlijk dat je met 10 moest vermenigvuldigen. Maar bij kubiek is het ×1000: 0,06 × 1000 = 60 liter. Onthoud: kubiek = drie keer ×10 = ×1000."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.kubiek-x100-i.p.v.-x1000", "label": "Past oppervlakte-regel toe", "optionIndex": 0 },
          { "id": "met.kubiek-x10000-i.p.v.-x1000", "label": "Vermenigvuldigt met verkeerde factor", "optionIndex": 2 },
          { "id": "met.kubiek-x10-i.p.v.-x1000", "label": "Past lengte-regel toe", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-OMREKEN-KUBIEK-004",
      "familyId": "MET-INH-OMREKEN-KUBIEK",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_kubiek_omreken",
      "questionType": "multiple_choice",
      "question": "Hoeveel cm³ is 2,5 dm³?",
      "options": ["250 cm³", "25 cm³", "25.000 cm³", "2500 cm³"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "dm³ naar cm³",
            "content": "1 dm = 10 cm. Kubiek: 10 × 10 × 10 = 1000. Dus 1 dm³ = 1000 cm³.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_kubiek_dm3_cm3",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "1 dm = 10 cm. Bij kubiek: 10 × 10 × 10 = 1000. Dus 1 dm³ = 1000 cm³. Dan: 2,5 × 1000 = 2500 cm³. Onthoud het patroon: lengte ×10, oppervlakte ×100, kubiek ×1000.",
        "solutionSteps": [
          "1 dm = 10 cm (lengte)",
          "Kubiek: 10 × 10 × 10 = 1000",
          "1 dm³ = 1000 cm³",
          "2,5 × 1000 = 2500 cm³"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je met 100 moest vermenigvuldigen. Dat geldt voor vierkante maten, niet kubieke. Bij kubiek: ×1000. Dus 2,5 × 1000 = 2500. Onthoud: kubiek = ×1000.",
          "1": "Je dacht waarschijnlijk dat je met 10 moest vermenigvuldigen. Dat geldt voor lengte. Bij kubiek vermenigvuldig je drie keer: 10 × 10 × 10 = 1000. Onthoud: kubiek = ×1000.",
          "2": "Je dacht waarschijnlijk dat je met 10.000 moest vermenigvuldigen. Maar dm³ → cm³ = ×1000, niet ×10.000. Onthoud: kubiek = ×1000 per stap op het trapje.",
          "3": "Goed! 1 dm³ = 1000 cm³, dus 2,5 × 1000 = 2500 cm³."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.kubiek-x100-i.p.v.-x1000", "label": "Past oppervlakte-regel toe", "optionIndex": 0 },
          { "id": "met.kubiek-x10-i.p.v.-x1000", "label": "Past lengte-regel toe", "optionIndex": 1 },
          { "id": "met.kubiek-x10000-i.p.v.-x1000", "label": "Vermenigvuldigt met verkeerde factor", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-INH-OMREKEN-KUBIEK-005",
      "familyId": "MET-INH-OMREKEN-KUBIEK",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_kubiek_omreken",
      "questionType": "fill_in",
      "question": "Een zwembad heeft een inhoud van 0,5 m³. Hoeveel liter is dat? Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["500", "500 liter"],
        "caseSensitive": false,
        "placeholder": "? liter"
      },
      "stimulusAids": [{"type": "stairs", "data": {"type": "volume", "from": "m³", "to": "liter", "label": "Kubieke maten en liters: 1 m³ = 1000 liter"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "m³ naar liter",
            "content": "1 m³ = 1000 dm³ = 1000 liter. Dus 0,5 m³ = 0,5 × 1000 = 500 liter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_kubiek_m3_liter_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "1 m³ = 1000 dm³ = 1000 liter. Dus 0,5 m³ = 0,5 × 1000 = 500 liter. Onthoud: bij kubieke maten ga je steeds ×1000 per stap op het metrieke trapje. 1 m³ is een kubus van 1 m × 1 m × 1 m — dat is heel veel water!",
        "solutionSteps": [
          "1 m³ = 1000 dm³ = 1000 liter",
          "0,5 × 1000 = 500 liter",
          "Check: een halve kubieke meter = 500 liter ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.kubiek-dm3-liter-misverstand", "label": "Maakt fout bij omrekenen van m³ naar liter" }
        ]
      }
    }
  ]
}